import React, { useEffect } from 'react';
import { TitleContainer, StyledButton, ButtonText, ButtonContainerGap, ModalTitleSmall } from './ModalComponent.styles';
import Modal from './Modal';
import { Waveform } from '@uiball/loaders';

const AreYouSureModal = ({ open, onClose, width, height, loading, onClick }) => {
  const handleKeyDown = e => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <Modal isOpen={open} width={width} onClose={onClose} height={height} fade>
      <div>
        <TitleContainer>
          <ModalTitleSmall>Are you sure you want to cancel subscription?</ModalTitleSmall>
        </TitleContainer>
      </div>
      <ButtonContainerGap>
        <StyledButton disabled={loading} onClick={onClose}>
          <ButtonText>Cancel</ButtonText>
        </StyledButton>

        <StyledButton onClick={onClick} disabled={loading} $black>
          {!loading ? (
            <ButtonText $black>Yes</ButtonText>
          ) : (
            <Waveform size={26} lineWeight={3.5} speed={1} color="white" />
          )}
        </StyledButton>
      </ButtonContainerGap>
    </Modal>
  );
};

export default AreYouSureModal;
